import {Option} from 'platform/components';

import {isNotNil} from 'ramda';

import {SupplierAccount} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

/**
 * Builds select options from supplier accounts, dropping any entry without a usable value
 * or label. The backend may return accounts with a `null` value; such entries must not be
 * selectable.
 */
export const getOptionsFromSupplierAccounts = (
  supplierAccounts: SupplierAccount[] | Nullish
): Option[] =>
  (supplierAccounts ?? []).reduce<Option[]>((options, account) => {
    if (isNotNil(account.value) && isNotNil(account.label)) {
      options.push({label: account.label, value: account.value});
    }

    return options;
  }, []);
